import { useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    createFetchGridDataset,
    fetchDatasets,
    gridDatasetSelector
} from '@libs/datasets';
import { makeSideEffectCallback } from '@libs/makeContext';

import { YearlyTimesheetsProvider } from './useYearlyTimesheets';
import { MY_YEARLY_ATTENDANCE } from 'timeAndAttendance/redux.datasets';
import { DOMAIN_NAME } from 'timeAndAttendance/common';
import Filters from './Filters';
import Content from './Content';

const TimesheetsYearlyView = () => {
    const data = useSelector((state) =>
        gridDatasetSelector(state, DOMAIN_NAME, MY_YEARLY_ATTENDANCE)
    );
    const dispatch = useDispatch();

    const fetchYearlyAttendance = useCallback(
        () => dispatch(fetchDatasets(MY_YEARLY_ATTENDANCE)),
        [dispatch]
    );
    const fetchGridYearlyDataset = useCallback(
        (payload) =>
            dispatch(
                createFetchGridDataset(
                    DOMAIN_NAME,
                    MY_YEARLY_ATTENDANCE
                )(payload)
            ),
        [dispatch]
    );

    const initialize = useCallback(
        (state) => ({
            ...state,
            data
        }),
        [data]
    );

    const middlewareProps = useMemo(
        () => ({
            fetchData: makeSideEffectCallback(fetchGridYearlyDataset)
        }),
        [fetchGridYearlyDataset]
    );

    useEffect(() => {
        fetchYearlyAttendance();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <YearlyTimesheetsProvider
            initialize={initialize}
            middlewareProps={middlewareProps}
        >
            <Filters />
            <Content />
        </YearlyTimesheetsProvider>
    );
};

export default TimesheetsYearlyView;
